import { Form, Field } from "react-final-form";
import { Row, Col } from "react-bootstrap";
import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";

import Label from "../../reuseableComponents/label/Label";
import { ReactSelectAdapter } from "../../reuseableComponents/forms/ReactSelectAdapter";
import {
  GET_ALL_IPS_DEFICIENCIES,
  ADD_NEW_DEFICIENCY,
  UPDATE_DEFICIENCY,
  DEACTIVATE_DEFICIENCY,
  ACTIVATE_DEFICIENCY
} from "../../../queries/archiveQrys/secureQrys/ipsDeficiencyQrys";
import ButtonSubmit from "../../reuseableComponents/buttons/ButtonSubmit";
import ButtonBasic from "../../reuseableComponents/buttons/ButtonBasic";
import ButtonProcessing from "../../reuseableComponents/buttons/ButtonProcessing";
import { UserContext } from "../../reuseableComponents/auth/UserContext";

const severities = [
  {
    value: "MIN",
    label: "MIN"
  },
  {
    value: "SIG",
    label: "SIG"
  },
  {
    value: "REC",
    label: "REC"
  }
];

let points = [
  { value: 0, label: "0" },
  { value: 5, label: "5" },
  { value: 15, label: "15" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
  { value: 150, label: "150" },
  { value: 200, label: "200" }
];

const IpsDeficiencyForm = ({
  defCodes,
  item,
  id,
  successMsg,
  errorMsg,
  setSubmitSuccess,
  setSubmitError,
  handleClose
}) => {
  const [formSubmitting, setFormSubmitting] = useState(false);

  const [addDeficiency] = useMutation(ADD_NEW_DEFICIENCY, {
    refetchQueries: [{ query: GET_ALL_IPS_DEFICIENCIES }],
    awaitRefetchQueries: true
  });

  const [updateDeficiency] = useMutation(UPDATE_DEFICIENCY, {
    refetchQueries: [{ query: GET_ALL_IPS_DEFICIENCIES }],
    awaitRefetchQueries: true
  });

  const [deactivateDeficiency] = useMutation(DEACTIVATE_DEFICIENCY, {
    refetchQueries: [{ query: GET_ALL_IPS_DEFICIENCIES }],
    awaitRefetchQueries: true
  });

  const [activateDeficiency] = useMutation(ACTIVATE_DEFICIENCY, {
    refetchQueries: [{ query: GET_ALL_IPS_DEFICIENCIES }],
    awaitRefetchQueries: true
  });

  const { user } = useContext(UserContext);
  const username = user.firstName.charAt(0).toLowerCase() + user.lastName.toLowerCase();
  const today = new Date();

  if (id !== "Deactivate" && id !== "Activate") {
    if (item?.ipsPoints !== undefined && item.ipsPoints !== null) {
      id = "Edit";
    } else {
      id = "Add";
    }
  }

  const onSubmit = (data) => {
    setFormSubmitting(true);

    if (data.ipsPoints.value === "" || !points.some(point => point.value === data.ipsPoints.value)) {
      setSubmitError("Please select a value for points per deficiency from the dropdown menu");
      setFormSubmitting(false);
      return;
    }

    if (id === "Add") {
      addDeficiency({
        variables: {
          ...data,
          typeCode: data.typeCode.value,
          ipsPoints: data.ipsPoints.value,
          ruleName: data.ruleName,
          reportText: data.reportText,
          severity: data.severity.value
        },
        onCompleted: (data) => {
          setSubmitSuccess("Deficiency Created");
          setFormSubmitting(false);
          setTimeout(() => {
            handleClose();
          }, 4000);
        },
        onError: (error) => {
          setSubmitError("An Error Occured: ");
          setFormSubmitting(false);
        }
      });
    }
    if (id === "Edit") {
      console.log("Edit data: ", data);
      console.log("Edit item: ", item);
      const skipKeys = ["lastUpdateDate", "lastUpdateUser", "typeCode", "severity"];
      const isDataChanged = Object.keys(data).some((key) => {
        if (skipKeys.includes(key)) {
          console.log("Skipping key: ", key);
          return false;
        }
        if (key === "ipsPoints") {
          return data[key]?.value !== item[key];
        }
        console.log("Key: ", key);
        console.log(data[key] !== item[key]);
        return data[key] !== item[key];
      });

      console.log("dataChanged 2: ", isDataChanged);
      if (!isDataChanged) {
        setFormSubmitting(false);
        setSubmitError("Please edit a value before submitting");
        return
      }

      updateDeficiency({
        variables: {
          ...data,
          typeCode: data.typeCode.value,
          ipsPoints: data.ipsPoints.value,
          ruleName: data.ruleName,
          reportText: data.reportText
        },
        onCompleted: (data) => {
          setSubmitError(null);
          setSubmitSuccess("Deficiency Updated");
          setTimeout(() => {
            handleClose();
          }, 2000);
          setFormSubmitting(false);
        },
        onError: (error) => {
          setFormSubmitting(false);
          setSubmitError("Error Updating");
          setSubmitSuccess(null);
        }
      });
    }
    if (id === "Deactivate") {
      deactivateDeficiency({
        variables: {
          typeCode: data.typeCode
        },
        onCompleted: (data) => {
          setSubmitError(null);
          setSubmitSuccess("Deficiency Deactivated");
          setFormSubmitting(false);
          setTimeout(() => {
            handleClose();
          }, 2000);
        },
        onError: (error) => {
          setSubmitError("Error Deactivating");
          setSubmitSuccess(null);
          setFormSubmitting(false);
        }
      });
    }
    if (id === "Activate") {
      activateDeficiency({
        variables: {
          typeCode: data.typeCode
        },
        onCompleted: (data) => {
          setSubmitError(null);
          setSubmitSuccess("Deficiency Activated");
          setFormSubmitting(false);
          setTimeout(() => {
            handleClose();
          }, 2000);
        },
        onError: (error) => {
          setSubmitError("Error Activating" + JSON.stringify(error));
          setSubmitSuccess(null);
          setFormSubmitting(false);
        }
      });
    }
  };

  return (
    <>
      <Row>
        <Col>
          <Form
            onSubmit={onSubmit}
            keepDirtyOnReinitialize
            initialValues={
              item
                ? {
                    ...item,
                    typeCode: { label: item.typeCode + " / " + item.typeDesc, value: item.typeCode },
                    severity: { label: item.severity, value: item.severity },
                    ipsPoints: { label: item.ipsPoints !== null ? item.ipsPoints : "", value: item.ipsPoints !== null ? item.ipsPoints : undefined },
                    lastUpdateUser: username,
                    lastUpdateDate: today.toISOString()
                  }
                : { lastUpdateUser: username, lastUpdateDate: today.toISOString() }
            }
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                {id === "Deactivate" && (
                  <div>
                    {item && <p>Are you sure you want to deactivate deficiency {item.typeCode}?</p>}
                    <Row>
                      <Col>
                        {formSubmitting ? (
                          <ButtonProcessing label='Deactivating' id='ddw-primary' style={{ float: "right" }} disabled />
                        ) : (
                          <ButtonBasic
                            label='Deactivate'
                            id='ddw-primary'
                            style={{ float: "right" }}
                            onClick={() => onSubmit(item)}
                          />
                        )}
                      </Col>
                      {errorMsg && !formSubmitting && <span className='error'>{errorMsg}</span>}
                      {successMsg && !formSubmitting && <span className='success'>{successMsg}</span>}
                    </Row>
                  </div>
                )}
                {id === "Activate" && (
                  <div>
                    {item && <p>Are you sure you want to activate deficiency {item.typeCode}?</p>}
                    <Row>
                      <Col>
                        {formSubmitting ? (
                          <ButtonProcessing label='Activating' id='ddw-primary' style={{ float: "right" }} disabled />
                        ) : (
                          <ButtonBasic
                            label='Activate'
                            id='ddw-primary'
                            style={{ float: "right" }}
                            onClick={() => onSubmit(item)}
                          />
                        )}
                      </Col>
                      {errorMsg && !formSubmitting && <span className='error'>{errorMsg}</span>}
                      {successMsg && !formSubmitting && <span className='success'>{successMsg}</span>}
                    </Row>
                  </div>
                )}
                {id !== "Deactivate" && id !== "Activate" && (
                  <>
                    <Row>
                      <Col>
                        {/*TODO require drop down item gets selected typeCode and severity */}
                        <Label htmlFor='def-code' label='Type / Description' required={id !== "Edit"} />
                        <Field
                          name='typeCode'
                          component={ReactSelectAdapter}
                          options={defCodes}
                          className='mb-4'
                          disabled={id === "Edit" || id === "Add" || formSubmitting}
                          required
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Label htmlFor='ips-points' label='Points Per Deficiency' required />
                        <Field
                          name='ipsPoints'
                          component={ReactSelectAdapter}
                          options={points}
                          className={formSubmitting ? "form-control-plaintext mb-4" : "mb-4"}
                          disabled={formSubmitting}
                          required={true}
                        />
                      </Col>
                      <Col>
                        <Label htmlFor='severity' label='Severity' />
                        <Field
                          name='severity'
                          component={ReactSelectAdapter}
                          options={severities}
                          className='mb-4'
                          disabled={id === "Edit" || id === "Add" || formSubmitting}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Label htmlFor='rule-name' label='Rule Name' required />
                        <Field
                          name='ruleName'
                          component='input'
                          type='text'
                          className={formSubmitting ? "form-control-plaintext mb-4" : "form-control mb-4"}
                          disabled={formSubmitting}
                          required={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Label htmlFor='report-text' label='Report Text' required />
                        <Field
                          name='reportText'
                          component='textarea'
                          className={formSubmitting ? "form-control-plaintext" : "form-control mb-4"}
                          rows={5}
                          disabled={formSubmitting}
                          required={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {formSubmitting ? (
                          <ButtonProcessing id='ddw-primary' style={{ float: "right" }} disabled />
                        ) : (
                          <ButtonSubmit id='ddw-primary' style={{ float: "right" }} />
                        )}
                      </Col>
                      {errorMsg && !formSubmitting && <span className='error'>{errorMsg}</span>}
                      {successMsg && !formSubmitting && <span className='success'>{successMsg}</span>}
                    </Row>
                  </>
                )}
              </form>
            )}
          />
        </Col>
      </Row>
    </>
  );
};

export default IpsDeficiencyForm;
